import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return {
      leadId: Number,
      followUpId: Number,
      recipient: String,
    }
  }

  open() {
    var newMessageUrl = `/messages/new?message[to]=${encodeURIComponent(this.recipientValue)}`

    if (this.leadIdValue > 0) {
      newMessageUrl += `&message[lead_id]=${this.leadIdValue}`
    }

    if (this.followUpIdValue > 0) {
      newMessageUrl += `&message[follow_up_id]=${this.followUpIdValue}`
    }

    fetch(newMessageUrl, { credentials: "same-origin" })
      .then((response) => {
        if (response.ok) {
          return response.text()
        }

        throw new Error(response.statusText)
      })
      .then((html) => {
        let alreadyExistingComposeModal = document.querySelector("#compose-modal")
        if (alreadyExistingComposeModal) {
          alreadyExistingComposeModal.remove()
        }

        $("body").append(html)
        App.modal("#compose-modal", "show")
      })
      .catch((error) => {
        App.displayFlash("danger", `The email couldn't be initialized (${error}).`)
      })
  }
}
